module.exports = require('./helpers/bundle-url').getBundleURL('81jXc') + "logo.c51670a8.svg";